import './App.css';
import Judging from "./page/judging";
import {useStore} from "./hooks/useStore";
import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {Box, CircularProgress, Modal, Tab, Tabs} from "@mui/material";
import Auth from "./page/auth";
import Versions from "./page/judging/fotter/versions";
import AggregateCompetitionLoad from "./page/judge_settings/AggregateCompetitionLoad";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/ru";
import dayjs from "dayjs";
import api from "./api/api";
import {toast} from "react-toastify";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#EAEAEA',
    p: 4,
    borderRadius: '3px',
    maxWidth: '70%',
    width: '100%'
};

dayjs.locale("ru");

const App = observer(() => {

    const {global} = useStore();
    const [isAuth, setIsAuth] = useState(false);
    const [loading, setLoading] = useState(true);
    const [select, setSelect] = useState(null);
    const [showButtonChoose, setShowButtonChoose] = useState(false);
    const [tab, setTab] = useState(0);
    const [date, setDate] = useState(dayjs());
    const [exportCompetition, setExportCompetition] = useState(null);
    const [exportList, setExportList] = useState([]);

    useEffect(() => {

        if (!isAuth) return;

        const load = async () => {
            if (tab === 0) {
                await global.getList({year: date.year(), month: date.month() + 1});
            }

            if (tab === 1) {
                await loadExportList();
            }
        };

        load().then();

    }, [date, tab, isAuth]);

    useEffect(() => {

        const init = async () => {
            if (isAuth) {
                const isCreated = await global.getStatus();

                if (isCreated === false) {
                    await global.getList({year: date.year(), month: date.month() + 1});
                }
            }
        };

        init();

    }, [isAuth]);

    useEffect(() => {
        const token = localStorage.getItem('token');
        setIsAuth(Boolean(token));
        setTimeout(() => setLoading(false), 0);
    }, []);

    if (loading) return null;

    if (!isAuth) {
        return (
            <Auth setIsAuth={setIsAuth}/>
        );
    }

    const loadExportList = async () => {
        try {
            const res = await api().get("/aggregate/load-competition-list", {
                params: {
                    year: date.year(),
                    month: date.month() + 1
                }
            });

            setExportList(res.data || []);

        } catch (e) {
            setExportList([]);
        }
    };

    const loadCompetition = async () => {

        if (tab === 0) {
            if (select !== null) {
                setShowButtonChoose(true);
                await global.chooseSelect(select);
                setShowButtonChoose(false);
            }
        } else {
            if (!exportCompetition) return;
            setShowButtonChoose(true);
            try {
                const res = await api().post("/aggregate/export-competition", {
                        serverId: null,
                        url: null,
                        competitionId: exportCompetition
                    }
                );
                const msg = res?.data?.msg || res?.data;
                if (res?.data?.status === "ok") {
                    toast.success(typeof msg === "string" ? msg : "Готово");
                    setTimeout(() => window.location.reload(), 1000);
                } else {
                    toast.error(typeof msg === "string" ? msg : "Ошибка");
                }
            } catch (e) {
                toast.error(e?.response?.data?.msg || "Ошибка");
            } finally {
                setShowButtonChoose(false);
            }
        }
    };

    return (

        <div className="App">
            <Judging/>
            <Versions/>
            <Modal
                open={!global.isOpen}
                onClose={() => {
                }}
            >
                <Box sx={style}>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="ru"
                    >
                        <Tabs
                            value={tab}
                            onChange={
                                (e, v) => setTab(v)
                            }
                            centered
                            sx={{
                                marginBottom: "20px"
                            }}
                        >

                            <Tab label="Создать новое соревнование"/>
                            <Tab label="Загрузить сохранённое соревнование"/>

                        </Tabs>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "20px"
                            }}
                        >
                            <DatePicker
                                views={["year", "month"]}
                                value={date}
                                onChange={setDate}
                                label="Период"
                                sx={{
                                    width: "300px"
                                }}
                            />
                            <button
                                className="btn"
                                style={{
                                    width: "180px",
                                    height: "40px",
                                    border: "none"
                                }}
                                disabled={showButtonChoose || (tab === 0 ? !select : !exportCompetition)}
                                onClick={loadCompetition}
                            >
                                {showButtonChoose &&
                                    <CircularProgress
                                        size="12px"
                                        color="inherit"
                                        style={{
                                            marginRight: "10px"
                                        }}
                                    />
                                }
                                Загрузить
                            </button>
                        </div>
                        {tab === 0 &&
                            <div
                                style={{
                                    width: "100%",
                                    height: "420px",
                                    overflowY: "scroll",
                                    background: "#fff",
                                    borderRadius: "5px",
                                    border: "1px solid #ddd"
                                }}
                            >
                                <table
                                    style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        tableLayout: "fixed"
                                    }}
                                >
                                    <thead>
                                    <tr style={{
                                        textAlign: 'center',
                                        position: "sticky",
                                        top: 0,
                                        background: "#f5f5f5",
                                        zIndex: 2,
                                        borderBottom: "2px solid #ddd"
                                    }}>
                                        <th style={{
                                            width: '60px',
                                            padding: "10px",
                                            textAlign: "left",
                                            fontWeight: 600
                                        }}>ID
                                        </th>
                                        <th style={{
                                            padding: "10px",
                                            textAlign: "left",
                                            fontWeight: 600
                                        }}>Название
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {global?.list?.map(el => (
                                        <tr
                                            key={el.id}
                                            onClick={() => {
                                                setSelect(el.competition_id);
                                            }}
                                            style={{
                                                cursor: "pointer",
                                                background: select === el.competition_id ? "#58A2E4" : "transparent",
                                                transition: "0.15s"
                                            }}
                                        >
                                            <td style={{
                                                padding: "10px",
                                                borderBottom: "1px solid #eee"
                                            }}>
                                                {el.competition_id}
                                            </td>
                                            <td style={{
                                                padding: "10px",
                                                borderBottom: "1px solid #eee",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap"
                                            }}>
                                                {el.competition_name}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        }

                        {tab === 1 &&
                            <AggregateCompetitionLoad competitions={exportList}
                                                      selectedCompetition={exportCompetition}
                                                      onSelect={setExportCompetition}/>}

                    </LocalizationProvider>

                </Box>
            </Modal>
        </div>
    );
});

export default App;